import { render, staticRenderFns } from "./ReturnsReportView.vue?vue&type=template&id=4e0b5ff2&scoped=true"
import script from "./ReturnsReportView.vue?vue&type=script&lang=js"
export * from "./ReturnsReportView.vue?vue&type=script&lang=js"
import style0 from "./ReturnsReportView.vue?vue&type=style&index=0&id=4e0b5ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0b5ff2",
  null
  
)

export default component.exports